import React, {FC, useState} from "react"
import Typography from "../../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import SelectedFilters from "../SelectedFilters/SelectedFilters"
import {CollectionName} from "../../../constants"
import FilterDropdownItem from "../dropdown/FilterDropdownItem"
import urlParams from "../../../utility/UrlParams"
import {X} from "react-bootstrap-icons"
import {useRouter} from "next/router"
import {defaultValue} from "../Config"
import {CollectionViewSelector} from "../../collection"
import ProductSort from "../ProductSort"

type Props = {
	filteredProductsLength: number
	collectionName: CollectionName
	categories?: any
	accessoryCategories?: any
	isLoading:boolean
}

const bioBikesList = [
	"Rennvelos",
	"Gravel Bikes",
	"Fully Velo"
]

const FilterHorizontalSection: FC<Props> = ({filteredProductsLength, categories, collectionName, accessoryCategories, isLoading}) => {
	const {t} = useTranslation(["common", "filters"])
	const router = useRouter()
	const {page, ...params} = router.query
	const bioBikeCatName = "bike"
	const bikesFoundTKey = params?.categories === bioBikeCatName ? "bikes-found" : "products-found"
	const accessoriesFoundKey = filteredProductsLength === 1 ? "accessory-article" : "aaccessories-articles"
	const [searchValueButtonSpinner, setSearchValueButtonSpinner] = useState(false)
	const filterSearchValue = params[urlParams.searchValue] ?
		params[urlParams.searchValue] !== defaultValue ? params[urlParams.searchValue] : "" : ""

	const asPathWithoutQuery = (asPath:string) => {
		return asPath.split("?")[0]
	}

	const handleSearchButtonClick = async () => {
		setSearchValueButtonSpinner(true)

		const {query, pathname, asPath} = router
		delete query.searchValue

		// @ts-ignore
		const queryString = decodeURIComponent(new URLSearchParams(query).toString())
		await router.push(`${pathname}?${queryString}`, `${asPathWithoutQuery(asPath)}?${queryString}`, {
			shallow: true,
			scroll: false
		})

		setSearchValueButtonSpinner(false)
	}

	return (
		<>
			<div className="d-flex flex-column align-items-start justify-content-start mb-4">
				{filterSearchValue && <div className="d-flex flex-row align-items-center ps-1 mb-4">
					<Typography variant="bodySmBold"
						style={{marginRight: "8px"}}>{`${t("search")}:`}</Typography>
					<button
						disabled={searchValueButtonSpinner}
						onClick={handleSearchButtonClick}
						className="btn col-auto d-flex align-items-center justify-content-center me-2 mt-2 mt-md-0  mb-md-0 grey-hover"
						style={{
							height: 40,
							padding: "10px 12px 10px 16px",
							borderRadius: 16,
							backgroundColor: "#212529",
							border: "1px solid #212529",
							color: "white"
						}}>
						{searchValueButtonSpinner && <span style={{color: "#fff"}}
							className="spinner-border spinner-border-sm text-white me-2"
							role="status"
							aria-hidden="true"/>}
						<Typography className="me-1"
							variant="bodySmBold">{decodeURI(filterSearchValue.toString())}</Typography>
						<X className="text-white p-0 cursor-pointer"
							width={26}
							height={26}/>
					</button>
				</div>}
				<div className="col-md-12 col-lg-12 d-flex align-items-center">

					{params?.categories?.includes(t("accessories-url-slug")) || params?.["accessory-type"] !== undefined ?
						<div className="row col-12 gx-2 align-items-center">
							{accessoryCategories?.options?.map(category =>
								<div className="col-auto px-0 d-flex align-items-center gy-2"
									style={{maxHeight: 40}}
									key={category.name}>
									<FilterDropdownItem key={category}
										isBoxShape={true}
										label={category.name}
										collectionName={CollectionName.Accessories}
										param={"accessory-type"}
										value={category.slug}/></div>
							)}
						</div> :
						<div className="d-flex col-12 px-0 align-items-center flex-wrap"
							style={{rowGap: 8}}>
							{params?.categories?.includes(bioBikeCatName) ?
								<>
									{categories?.filter(cat => bioBikesList.includes(cat.name)).map(category =>

										<div className="col-auto px-0 d-flex align-items-center gy-2"
											style={{maxHeight: 40}}
											key={category.id}>
											<FilterDropdownItem key={category}
												isBoxShape={true}
												label={category.name}
												param={categories?.name}
												value={category.slug}
												isSwissMade={category.slug === "swiss_made"}
											/></div>
									)}
								</> : params?.categories?.includes("e-bike") ?
									categories?.filter(cat => !bioBikesList.includes(cat.name)).map(category =>

										<div className="col-auto px-0 d-flex align-items-center gy-2"
											style={{maxHeight: 40}}
											key={category.id}>
											<FilterDropdownItem key={category}
												isBoxShape={true}
												label={category.name}
												param={categories?.name}
												value={category.slug}
												isSwissMade={category.slug === "swiss_made"}
											/></div>
									) :
									<>
										{categories && categories?.map(category =>
											<div className="col-auto px-0 d-flex align-items-center gy-2"
												style={{maxHeight: 40}}
												key={category.id}>
												<FilterDropdownItem key={category.slug}
													isBoxShape={true}
													label={category.name}
													param={categories?.name}
													value={category.slug}
													isSwissMade={category.slug === "swiss_made"}
												/>
											</div>
										)
										}

									</>
							}

						</div>
					}
				</div>
			</div>
			<SelectedFilters/>
			<div className="d-flex justify-content-between align-items-start">
				{isLoading ? null : <div className="row mb-4">
					<Typography className="col text-start"
						variant="bodySm"
						semanticTag="h3">
						{`${filteredProductsLength} ${collectionName === CollectionName.Accessories ? t(accessoriesFoundKey, {ns: "filters"}) : t(bikesFoundTKey, {ns: "filters"})}`}
					</Typography>
				</div>}
				<div className="d-none d-md-flex justify-content-end gap-4">
					<CollectionViewSelector/>
					<ProductSort collectionName={CollectionName.AllBikes}/>
				</div>
			</div>

		</>
	)
}

export default FilterHorizontalSection

